<script lang="ts">
    import Occasions from "../presentationals/Occasions.svelte";
    import Manager from "../application/models/Manager.ts";
    import TimeColumn from "../presentationals/TimeColumn.svelte";
    import Filter from "../application/models/Filter.ts";
    import {_} from 'svelte-i18n';

    export let manager: Manager;
    export let filter: Filter;

    let weekDays = ["mon", "tue", "wed", "thu", "fri","sat"];
</script>

<div class="is-hidden-mobile backColor">
    <div class="columns">
        <div class="column has-text-centered is-narrow bordered">
        </div>
        {#each weekDays as day}
            <div class="column has-text-centered bordered">
                <strong>{$_('weekDays.' + day)}</strong>
            </div>
        {/each}
    </div>
    <div class="columns">
        <div class="column is-narrow">
            <TimeColumn manager={manager}/>
        </div>
        {#each weekDays as day, i}
            <div class="column has-text-centered">
                <Occasions on:modalOpen manager={manager} occasionArray={manager.occasionManager.getOccasions($filter, i+1)}/>
            </div>
        {/each}
    </div>
</div>

<style>
    .bordered{border-bottom: 1px solid rgba(243, 243, 243, 0.25);}
    .backColor{background-color: rgba(255, 255, 255, 0.3)}
</style>
